module.exports = __webpack_public_path__ + "img/society3.3da922dd.jpg";